// extracted by mini-css-extract-plugin
module.exports = {"background":"LandingPage_background__9quFc","content":"LandingPage_content__2LV1F","startbutton":"LandingPage_startbutton__sveSf","title":"LandingPage_title__2hJSv"};